import { useRootStore } from './useRootStore';

export function useDrawStore() {
  const { drawStore } = useRootStore();
  return drawStore;
}
